/**
 * Categories Filter
 **/
document.addEventListener("DOMContentLoaded", function () {
  const filterAccordion = document.getElementById("categoriesFilterAccordion");
  const mobileContainer = document.querySelector(
    "#categoriesFilterOffcanvas .offcanvas-body"
  );
  const originalContainer = document.getElementById("categoriesFilterDesktop"); // Add this div in your HTML

  function moveFilter() {

    if (mobileContainer === null || filterAccordion === null || originalContainer === null) {
      return;
    }

    if (window.innerWidth < 992) {
      if (!mobileContainer.contains(filterAccordion)) {
        mobileContainer.appendChild(filterAccordion);
      }
    } else {
      if (originalContainer && !originalContainer.contains(filterAccordion)) {
        originalContainer.appendChild(filterAccordion);
      }
    }
  }
  // Initial placement
  moveFilter();

  // Re-evaluate on resize
  window.addEventListener("resize", moveFilter);
});
